import { get } from "lodash-es";

export const products = {
    authentication: "Login",
    dashboard: "Dashboard",
    search: "Search",
    reconciliation: "Reconciliation",

    reports: "Reports",
    packaged_reports: "Packaged reports",
    savedViews: "Saved views",

    analytics: "Analytics",
    benchmarks: "Benchmarks",
    authorizations: "Authorizations",
    settlements: "Sales and refunds",
    chargebacks: "Chargebacks",
    fees: "Fees",
    fraud: "All fraud",
    psd2: "PSD2",
    fraudsight: "Risk monitoring",
    "3ds": "3DS flex",
    comparisons: "Comparisons",

    profile: "Profile",
    preferences: "Preferences",
    alerts: "Alerts",
    security: "Change password",
    userManagement: "User management",
    dataAvailability: "Data availability",
    buManager: "BU manager",

    downloads: "Downloads",

    superuserTools: "Superuser tools",
    settings: "Settings",

    support: "Support",

    // eslint-disable-next-line sentence-case/sentence-case
    admin: "Admin UI",
    credentials: "Credentials",
    requests: "Requests",
    requestTool: "Requests",
    sessions: "Sessions",
    admin_users: "Users",
    merchants: "Merchants",
    // eslint-disable-next-line sentence-case/sentence-case
    admin_reports: "Admin reports",
    email: "Email analytics"
};

// TODO MATT: It is not ideal that this replicates the product routes.
// Consider unifying by either making product a prop to authRoute and removing this object
// OR generate Routes JSX from this object.
const productsRoutes = {
    merchant: {
        login: {
            title: products.authentication
        },
        dashboard: {
            title: products.dashboard
        },
        search: {
            title: products.search
        },
        reconciliation3: {
            title: products.reconciliation
        },
        reconciliation: {
            title: products.reconciliation
        },
        reports: {
            title: products.reports,
            packaged_reports: {
                title: products.packaged_reports
            },
            saved_reports: {
                title: products.savedViews
            }
        },
        analytics: {
            benchmarks: {
                title: products.benchmarks
            },
            authorizations: {
                title: products.authorizations
            },
            settlements: {
                title: products.settlements
            },
            chargebacks: {
                title: products.chargebacks
            },
            fees: {
                title: products.fees
            },
            cashflow: {
                title: products.cash_flow
            },
            all_fraud: {
                title: products.fraud
            },
            psd2_fraud: {
                title: products.psd2
            },
            fraudsight: {
                title: products.fraudsight
            },
            "3ds": {
                title: products["3ds"]
            }
        },
        preferences: {
            profile: {
                title: products.profile
            },
            preferences: {
                title: products.preferences
            },
            alerts2: {
                title: products.alerts
            },
            security: {
                title: products.security
            },
            users: {
                title: products.userManagement
            },
            data: {
                title: products.dataAvailability
            },
            bumanager: {
                title: products.buManager
            }
        },
        downloads: {
            title: products.downloads
        },
        dev: {
            tools: {
                title: products.superuserTools
            },
            settings: {
                title: products.settings
            }
        },
        support: {
            title: products.support
        },
        administrator: {
            // eslint-disable-next-line sentence-case/sentence-case
            title: products.admin,
            credentials: {
                title: products.credentials
            },
            requests: {
                title: products.requests
            },
            sessions: {
                title: products.sessions
            },
            users: {
                title: products.admin_users
            },
            merchant: {
                title: products.merchants
            },
            reports: {
                title: products.admin_reports
            },
            email: {
                title: products.email
            },
            downloads: {
                title: products.downloads
            }
        }
    },
    title: "Merchant" // default title
};

// Lookup a product by route fragment, giving the next-best match when possible.
export const fragmentToProduct = (fragment, mappings = productsRoutes) => {
    if (!fragment.length) return get(mappings, "title");
    const [first, ...rest] = fragment.split("/");
    const routes = get(mappings, first) || mappings;
    return fragmentToProduct(rest.join("/"), routes) || get(routes, "title");
};
